var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.items),function(item,index){return _c('span',{key:item,class:[
      _vm.$vmq.lg ? 'subtitle-1' : 'caption',
      index + 1 === _vm.items.length
        ? ''
        : 'primary--text text--darken-2 breadcrumb-hover',
    ],on:{"click":function($event){return _vm.itemClicked(item)}}},[_vm._v(" "+_vm._s(item)+" "),(index + 1 != _vm.items.length)?_c('v-icon',[_vm._v("mdi-chevron-right")]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }